import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, UsersIcon, CalendarIcon, ExternalLinkIcon } from 'lucide-react';
const CommunityCard = ({
  id,
  name,
  description,
  memberCount,
  location,
  category,
  nextEvent,
  websiteUrl,
  isEvent,
  difficulty,
  contact
}: {
  id: string;
  name: string;
  description: string;
  memberCount: number;
  location: string;
  category: string;
  nextEvent?: string;
  websiteUrl?: string;
  isEvent?: boolean;
  difficulty?: string;
  contact?: string;
}) => {
  return <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 transition-all duration-300 hover:border-gray-400 dark:hover:border-gray-500" data-id="element-69">
      <div className="flex justify-between items-start" data-id="element-70">
        <div data-id="element-71">
          <h3 className="font-bold dark:text-gray-200" data-id="element-72">{name}</h3>
          <div className="flex items-center mt-1 text-sm text-gray-600 dark:text-gray-400" data-id="element-73">
            <MapPinIcon className="w-4 h-4 mr-1" data-id="element-74" />
            <span data-id="element-75">{location}</span>
          </div>
          <div className="flex items-center mt-1 text-sm text-gray-600 dark:text-gray-400" data-id="element-76">
            <UsersIcon className="w-4 h-4 mr-1" data-id="element-77" />
            <span data-id="element-78">{memberCount} members</span>
          </div>
        </div>
        {difficulty && <div className="bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded text-xs" data-id="element-79">
            {difficulty}
          </div>}
      </div>
      <p className="text-sm text-gray-600 dark:text-gray-400 mt-3" data-id="element-80">
        {description}
      </p>
      {nextEvent && <div className="flex items-center mt-3 text-sm text-gray-600 dark:text-gray-400" data-id="element-81">
          <CalendarIcon className="w-4 h-4 mr-1" data-id="element-82" />
          <span data-id="element-83">Next: {nextEvent}</span>
        </div>}
      {contact && <div className="mt-3 text-sm text-gray-600 dark:text-gray-400 italic" data-id="element-84">
          {contact}
        </div>}
      <div className="mt-3 flex justify-between items-center" data-id="element-85">
        <Link to={`/community/${id}`} className="text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors duration-300" data-id="element-86">
          View details
        </Link>
        {websiteUrl && websiteUrl !== '#' && <a href={websiteUrl} target="_blank" rel="noopener noreferrer" className="flex items-center text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors duration-300" data-id="element-87">
            <span className="mr-1" data-id="element-88">Visit website</span>
            <ExternalLinkIcon className="w-3 h-3" data-id="element-89" />
          </a>}
        {isEvent && <button className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md text-sm dark:text-gray-200 transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-90">
            Register Interest
          </button>}
      </div>
    </div>;
};
export default CommunityCard;